module.exports = __webpack_public_path__ + "static/img/11_okinawa.0b3f5a7e.png";